import { Component, OnInit } from '@angular/core';
import { ContactUsMessage } from '../../models/contact-us-message';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactUsMessagesService } from '../../services/contact-us-messages.service';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';
import * as moment from 'moment';

@Component({
  selector: 'contact-us-message-details',
  templateUrl: './contact-us-message-details.component.html',
  styleUrls: ['./contact-us-message-details.component.scss']
})
export class ContactUsMessageDetailsComponent implements OnInit {
  model = {} as ContactUsMessage;
  formattedDateTime = "";
  formatReplyDateTime = "";
  constructor(private route: Router,
    private diag: NbDialogRef<ContactUsMessageDetailsComponent>,
    public sanitizer: DomSanitizer,
    public service: ContactUsMessagesService) { }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diag.close('false');
    });
    moment.locale('en');
    if (this.model.messageDate)
      this.formattedDateTime = moment(this.model.messageDate).format('DD/MM/YYYY hh:mm A');
    if (this.model.replyDate)
      this.formatReplyDateTime = moment(this.model.replyDate).format('DD/MM/YYYY hh:mm A');
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close() {
    this.diag.close();
  }

  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }


}


